<template>
    <div id="qr-code">
        <span class="mdi mdi-close icon-scale bigger close-button"
              @click="$emit('close')">
        </span>
        <div class="has-text-centered hn">
            HN {{ hn }}
        </div>
        <div class="tab-qr-code">
            <b-tabs type="is-toggle" v-model="tabSelected">
                <b-tab-item label="QR code">
                    <img v-if="qrCode"
                         :src="qrCode"
                         style="width: 150px; height: 150px;"
                         alt=""/>
                </b-tab-item>
                <b-tab-item label="Barcode">
                    <svg id="barcode" ref="barcode"
                         style="width: 150px; height: 150px;">
                    </svg>
                </b-tab-item>
            </b-tabs>
        </div>
        <div class="has-text-centered qr-code-footer">
          <span class="mdi mdi-information-outline"
                style="margin-right: .25rem;">
          </span>
          <span>โปรดเพิ่มแสงหน้าจอ</span>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import JsBarcode from 'jsbarcode'
import QRCode from 'qrcode'

export default {
  name: 'qrCodePopup',
  mounted () {
    // Generate QR Code
    QRCode.toDataURL(`${this.hn}`, { errorCorrectionLevel: 'H' })
      .then((url) => {
        this.qrCode = url
      })
      .catch((err) => {
        console.error(err)
      })
  },
  data () {
    return {
      qrCode: null,
      barcode: null,
      tabSelected: null
    }
  },
  computed: {
    ...mapState([
      'hn'
    ])
  },
  methods: {
    generateBarcodeHandler () {
      window.setTimeout(() => {
        JsBarcode(this.$refs['barcode'], this.hn)
      }, 100)
    }
  },
  watch: {
    tabSelected (val) {
      if (val === 1) {
        this.generateBarcodeHandler()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  #qr-code {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 1.3rem;
    padding: 1rem;
    margin: 1rem;
    height: 430px;

    .hn {
      margin-top: 1.5rem;
      margin-bottom: 1.5rem;
      font-size: 2rem;
      font-weight: bold;
    }

    .tab-qr-code {
      font-weight: bold;
      margin-bottom: 20px;
    }

    .qr-code-footer {
      color: #707070;
      font-family: 'Mitr', sans-serif;
      font-weight: 300;
      font-size: 16px;
    }
  }
</style>
